import React, {
    FC, useEffect
} from 'react';
import { View } from '@adobe/react-spectrum';

import { _engine } from '~/Services/Studio/studioScene';
import { CanvasGizmoIcon } from './Gizmo/canvasGizmoIcon';
import { CanvasScreenshot } from './Screenshot';
import { CanvasCameraPosition } from './Camera/canvasCamera';
import { CanvasFrame } from './Frame/canvasFrame';

export const Canvas: FC = () => {
    useEffect(() => {
        const container: HTMLCanvasElement = document.querySelector('#scene-container');
        container.appendChild(_engine.sceneContainer);
    }, []);

    return (
        <View
            width="100%"
            height="100%"
            position="relative"
            id="scene-container"
        >
            <CanvasCameraPosition />
            <CanvasGizmoIcon />
            <CanvasScreenshot />
            <CanvasFrame />
        </View>
    );
};
